export default __webpack_public_path__ + "static/102-a1a55adff2758264dc1f39f99489c9e5.gif";